import { SpraypaintBase } from 'spraypaint';
import { createSuccessfulSaveToast, createToast, createUnsuccessfulSaveToast } from '../../';

interface IHandleGraphitiUpdateProps {
  /**
   * Lowercase name of attribute or instance name e.g. 'webhook endpoint' or 'phone number' etc
   */
  name: string;
  /**
   * Graphiti instance that we'd like to update
   */
  resource: SpraypaintBase;
  /**
   * Callback function to run after everything
   */
  finalCallback?(): void;
  /**
   * Callback function to run after success
   */
  successCallback?(): void;
}

export function handleGraphitiUpdate({ finalCallback, name, successCallback, resource }: IHandleGraphitiUpdateProps) {
  const toastKey = resource.id;
  createToast({ isLoading: true, key: toastKey, text: `Updating ${name}...` });
  resource
    .save()
    .then((success) => {
      if (success) {
        createSuccessfulSaveToast({ name, toastKey, verb: 'updated' });
        if (successCallback) successCallback();
      } else {
        createUnsuccessfulSaveToast({ resource, toastKey, prefix: `Could not update ${name}` });
      }
    })
    .catch(() => {
      createToast({
        key: toastKey,
        text: 'There was an error performing this action. Please try again and contact support if the problem persists',
        type: 'error',
      });
    })
    .finally(() => {
      if (finalCallback) finalCallback();
    });
}
